<template>
  <main role="main">
    <public-banner class="banner" />
    <section class="error-page">
      <div>
        <img src="~@/assets/images/500-2x.png">
        <h2 v-t>Something went wrong</h2>
        <p>
          <span v-t>Something on our end went wrong. It's been reported to us and we're looking into it. Need help? </span>
          <a v-t onclick="window.Intercom('show')">Contact us.</a>
        </p>
      </div>
    </section>
  </main>
</template>

<script>
import { publicBanner } from '@/components/layout';
import getBrandConfig from '@/lib/utils/get_brand_config';

const brandConfig = getBrandConfig();

export default {
  head() {
    const title = this.$t('Unexpected error');
    return {
      title: `${title} | ${brandConfig.fullName}`,
    };
  },

  components: {
    publicBanner,
  },
};
</script>

<style lang="scss" scoped>

  .banner {
    border-bottom: 1px solid $pearl-300;
  }

  .error-page {
    flex: 1 0 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    min-height: fit-content;
    padding: 3rem 0;

    > div {
      align-items: center;
      display: flex;
      flex-flow: column nowrap;
      margin: 0 1rem;

      @media #{$screen-width-small} {
        max-width: 25rem;
      }

      img {
        width: 100%;
        max-width: 15rem;
      }

      h2 {
        margin-top: 2rem;
        text-align: center;
      }

      p {
        text-align: center;
        margin-top: 0.5rem;
      }
    }
  }
</style>
